<template>
  <div class="process-node layout">
    <div class="process-node-name">
      <div>{{node.name}}</div>
      <div v-if="!node.participants||!node.participants.length" class="process-node-desc">
        <span>请选择{{node.type==='notify'?'抄送':'审批'}}人</span></div>
      <div v-else-if="node.type==='notify'" class="process-node-desc">
        <span>抄送{{node.participants.length}}人</span>
      </div>
      <div v-else-if="node.participants.length===1" class="process-node-desc">
        <span>1人审批</span>
      </div>
      <div v-else="" class="process-node-desc">
        <span>{{node.participants.length}}人{{{'and':'会签','or':'或签','one_by_one':'依次审批'}[node.content.activate]}}</span>
      </div>
    </div>
    <participant v-model="node.participants" :options="node.content" class="flex"/>
  </div>
</template>

<script>
  import Participant from "./participant";

  export default {
    name: "process-node",
    props: ["node"],
    components: {Participant}
  }
</script>

<style scoped lang="scss">
  @import "../../../assets/css/global";

  .switch-mobile {
    .process-node .process-node-name {
      min-width: auto;
    }
  }

  .process-node {
    $node-height: 80px;
    $point-size: 12px;
    $line-left: 30px;
    $point-top: ($node-height - $point-size)/2;
    position: relative;
    min-height: $node-height;
    padding-left: $line-left*2;
    padding-right: $line-left;
    border-bottom: 1px solid darken($color-bg, 4%);
    /*align-items: center;*/
    &:before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: $line-left;
      width: 1px;
      background-color: $color-border;
    }
    &:first-child {
      &:before {
        top: $point-top;
      }
      &:last-child {
        &:before {
          display: none;
        }
      }
    }
    &:last-child {
      border-bottom: none;
      &:before {
        bottom: auto;
        height: $point-top;
      }
    }
    &:after {
      content: "";
      position: absolute;
      top: $point-top;
      width: $point-size;
      height: $point-size;
      left: $line-left - ($point-size - 2px)/2;
      border-radius: 50%;
      background-color: $color-border;
    }
    .process-node-name {
      font-size: 1.6rem;
      color: $color-font-deep;
      line-height: 1.2;
      padding-top: 25px;
      min-width: 100px;
      margin-right: 10px;
    }
    .process-node-desc {
      font-size: 1.2rem;
      color: $color-font-light;
    }
  }
</style>
